/**
 * AnonScoreBoxModal.js
 * Written by: Alex Kasemir
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Link } from '@minerva-analytics/pantheon';
import AnonScoreUpdate from 'containers/AnonScoreUpdate';

import event from 'utils/event';

import {
  Container,
} from './AnonScoreBoxModal.styles';

export default class AnonScoreBoxModal extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  hide = () => {
    const { onClose, data } = this.props;
    data.hideModal();
    onClose();
    event(`hide-modal`, [`click`, `hide-modal`]);
  }

  render() {
    const { data } = this.props;
    return (
      <Container>
        <AnonScoreUpdate
          score={ data.score }
          type="modal"
          onClose={ this.props.onClose }
        />
        <Link onClick={ this.hide }>
          Do not ask me again.
        </Link>
      </Container>
    );
  }
}

AnonScoreBoxModal.propTypes = {
  data: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
